(function(){
  'use strict';

  function sectionByKey(key){
    return document.querySelector('[id*="'+key+'"]');
  }

  function replaceContaining(root, selector, needle, replacement){
    if(!root) return;
    root.querySelectorAll(selector).forEach(function(el){
      if((el.textContent||'').indexOf(needle)!==-1){ el.textContent=replacement; }
    });
  }

  function hideCS5(root){
    (root||document).querySelectorAll('a[href*="chiro-supreme-5-0"]').forEach(function(a){
      var card=a.closest('.product-card, .card-product, .product-item, li, .grid__item, .swiper-slide');
      if(card){ card.style.display='none'; } else { a.style.display='none'; }
    });
  }

  function buildTrustBar(){
    var track=document.querySelector('.trl-trust-track');
    if(!track || track.dataset.trlFinalized==='1') return;
    var items=[
      ['✓','Standard Curbside Delivery Included','Canada & United States'],
      ['◆','Equipment Financing Options','For qualified purchases in Canada & the U.S.'],
      ['＋','Product Guidance Before Ordering','Compare tables by workflow and required functions'],
      ['●','Parts & Technical Support','Parts support and virtual technical assistance available']
    ];
    var html='';
    items.concat(items).forEach(function(item){
      html+='<div class="trl-trust-item"><span>'+item[0]+'</span><div><strong>'+item[1]+'</strong><small>'+item[2]+'</small></div></div>';
    });
    track.innerHTML=html;
    track.dataset.trlFinalized='1';
  }

  function finalizeLogoProof(){
    var logo=sectionByKey('logo_list_QdWHmp');
    var trust=sectionByKey('custom_liquid_xV9Mxi');
    if(!logo) return;
    if(trust && trust.nextElementSibling!==logo){ trust.after(logo); }
    if(!logo.querySelector('.trl-customer-logo-intro')){
      var intro=document.createElement('div');
      intro.className='trl-customer-logo-intro';
      intro.innerHTML='<span>REAL TRL CUSTOMERS</span><h2>Clinics That Chose TRL Tables</h2><p>A selection of chiropractic, physiotherapy, massage and rehabilitation clinics that have purchased TRL treatment tables.</p>';
      logo.prepend(intro);
    }
  }

  function removeRedundantHighlight(){
    var highlight=sectionByKey('highlight-text');
    if(highlight){ highlight.style.display='none'; }
  }

  function finalizeFeatured(){
    var section=sectionByKey('featured-collection');
    if(!section) return;
    var h=section.querySelector('h2,h3');
    if(h){ h.textContent='Featured Treatment Tables'; }
    replaceContaining(section,'p','Explore our latest TRL Tables collection','Compare a focused selection of TRL treatment tables for chiropractic, physiotherapy, massage and rehabilitation clinics. Choose by workflow, table function and the level of adjustability your treatment room needs.');
    hideCS5(section);
  }

  function finalizeWhyTRL(){
    var section=document.querySelector('.trl-tech-v10');
    if(!section) return;
    var review=section.querySelector('.trl-v10-review');
    if(review){ review.remove(); }
    var h=section.querySelector('.trl-v10-top h2');
    var p=section.querySelector('.trl-v10-top p');
    if(h){ h.textContent='Designed Around the Work Clinics Do Every Day'; }
    if(p){ p.textContent='From patient positioning to powered movement and table-assisted techniques, TRL platforms are built around practical clinical workflows—not feature lists alone.'; }
    var content=[
      ['Controlled Powered Movement','Selected TRL models use powered systems to support smooth, repeatable positioning.'],
      ['Practical Practitioner Access','Controls and adjustment points are positioned to keep common table functions within easy reach.'],
      ['Options for Different Workflows','Choose from elevation, drop, flexion-distraction, traction and decompression platforms based on how your clinic treats.'],
      ['Support Beyond the Purchase','TRL provides product guidance, parts support and virtual technical assistance when needed.']
    ];
    section.querySelectorAll('.trl-v10-feature').forEach(function(feature,i){
      if(!content[i]) return;
      var fh=feature.querySelector('h3');
      var fp=feature.querySelector('p');
      if(fh) fh.textContent=content[i][0];
      if(fp) fp.textContent=content[i][1];
    });
  }

  function remove707Comparison(){
    var section=document.querySelector('.trl-power-lab-v6');
    if(section){ section.remove(); }
  }

  function createFinancing(){
    if(document.querySelector('.trl-home-financing-final')) return;
    var video=sectionByKey('reveal-video-with-text-overlay');
    if(!video) return;
    var wrap=document.createElement('section');
    wrap.className='trl-home-financing-final';
    wrap.innerHTML='<div class="trl-hf-inner"><div class="trl-hf-kicker">EQUIPMENT FINANCING</div><h2>Preserve Working Capital While You Upgrade</h2><p class="trl-hf-lead">Qualified clinics can explore equipment-financing options in Canada and the United States. Financing is separate from TRL Tables and subject to lender approval and terms.</p><div class="trl-hf-grid"><div class="trl-hf-card"><span>CANADA</span><h3>National Bank / Nations Leasing</h3><p>Equipment-financing options for qualified Canadian business purchases.</p></div><div class="trl-hf-card"><span>UNITED STATES</span><h3>NCMIC Equipment Finance</h3><p>Equipment-financing options for qualified U.S. chiropractic and healthcare practices.</p></div></div><div class="trl-hf-actions"><a class="trl-hf-primary" href="/pages/contact">Ask About Financing →</a><a class="trl-hf-secondary" href="/collections/all">Shop Treatment Tables</a></div><small>Programs, eligibility, approval and financing terms are determined by the financing provider.</small></div>';
    video.before(wrap);
  }

  function finalizeVideo(){
    var video=sectionByKey('reveal-video-with-text-overlay');
    if(!video) return;
    var h=video.querySelector('h2,h3');
    if(h){ h.textContent='See TRL Tables in Real Clinical Environments'; }
    video.querySelectorAll('a').forEach(function(a){
      if((a.textContent||'').toLowerCase().indexOf('read our story')!==-1){
        a.textContent='Talk to a Product Advisor';
        a.setAttribute('href','/pages/contact');
      }
    });
  }

  function removeManualReviews(){
    var a=sectionByKey('client_reviews_carousel_JmTNpT');
    var b=sectionByKey('reveal-testimonials');
    if(a){ a.style.display='none'; }
    if(b){ b.style.display='none'; }
  }

  function createAuthenticReview(){
    if(document.querySelector('.trl-authentic-review')) return;
    var about=sectionByKey('images-with-text');
    if(!about) return;
    var review=document.createElement('section');
    review.className='trl-authentic-review';
    review.innerHTML='<div class="trl-ar-inner"><div class="trl-ar-kicker">VERIFIED BUYER REVIEW</div><div class="trl-ar-stars" aria-label="5 star review">★★★★★</div><blockquote>“Even the basic model has all the features I was wanting. The table is wide but still easy to navigate around while doing body work. The head/face cradle and amount of cushion/support all seem just right according to my patients so far as well.”</blockquote><p><strong>Daniel McEowen</strong><span>Verified buyer · Model 3 Basic · Review collected through the store</span></p></div>';
    about.before(review);
  }

  function finalizeAbout(){
    var about=sectionByKey('images-with-text');
    if(!about) return;
    replaceContaining(about,'p','TRL Tables designs and builds clinical-grade therapy tables trusted by chiropractors','TRL Tables designs treatment tables for chiropractic, physiotherapy, massage and rehabilitation clinics across Canada and the United States. Our focus is practical table design, durable construction, product guidance and ongoing parts and technical support so clinics can choose equipment that fits the way they work.');
  }

  function createFinalCTA(){
    if(document.querySelector('.trl-home-final-cta')) return;
    var feed=sectionByKey('shop-the-feed');
    var about=sectionByKey('images-with-text');
    var anchor=feed||about;
    if(!anchor) return;
    var cta=document.createElement('section');
    cta.className='trl-home-final-cta';
    cta.innerHTML='<div class="trl-hc-inner"><span>NEED HELP CHOOSING?</span><h2>Not Sure Which Table Fits Your Clinic?</h2><p>Tell us your discipline, treatment workflow and the functions you need. We’ll help narrow the options before you order.</p><div><a href="/pages/contact">Get Product Guidance →</a><a href="/collections/all">Shop Treatment Tables</a></div></div>';
    anchor.after(cta);
  }

  function moveSections(){
    var selector=sectionByKey('custom_liquid_Uh9WFx');
    var featured=sectionByKey('featured-collection');
    var why=sectionByKey('custom_liquid_pmwLHT');
    var video=sectionByKey('reveal-video-with-text-overlay');
    var about=sectionByKey('images-with-text');
    var feed=sectionByKey('shop-the-feed');
    var logo=sectionByKey('logo_list_QdWHmp');
    if(logo && selector && logo.nextElementSibling!==selector){ logo.after(selector); }
    if(selector && featured && selector.nextElementSibling!==featured){ selector.after(featured); }
    if(featured && why && featured.nextElementSibling!==why){ featured.after(why); }
    if(video && about && video.compareDocumentPosition(about)&Node.DOCUMENT_POSITION_PRECEDING){ video.after(about); }
    if(about && feed && about.nextElementSibling!==feed){ about.after(feed); }
  }

  function injectStyles(){
    if(document.getElementById('trl-home-final-styles')) return;
    var style=document.createElement('style');
    style.id='trl-home-final-styles';
    style.textContent='\
      .trl-customer-logo-intro{max-width:1180px;margin:0 auto;padding:54px 22px 22px;text-align:center}.trl-customer-logo-intro>span,.trl-hf-kicker,.trl-ar-kicker,.trl-hc-inner>span{display:block;color:#c4161c;font-size:10px;font-weight:950;letter-spacing:.18em;text-transform:uppercase}.trl-customer-logo-intro h2,.trl-home-financing-final h2,.trl-home-final-cta h2{margin:10px auto 0;color:#0b0b0b;font-size:clamp(32px,4vw,58px);line-height:1;letter-spacing:-.05em;font-weight:950}.trl-customer-logo-intro p{max-width:760px;margin:13px auto 0;color:rgba(0,0,0,.62);font-size:15px;line-height:1.55}.trl-trust-item small{display:block;margin-top:3px;color:rgba(255,255,255,.58);font-size:10.5px;line-height:1.3}.trl-home-financing-final{padding:88px 22px;background:#0b0c0f;color:#fff}.trl-hf-inner{max-width:1180px;margin:0 auto}.trl-home-financing-final h2{max-width:850px;margin-left:0;color:#fff}.trl-hf-lead{max-width:760px;margin:18px 0 0;color:rgba(255,255,255,.7);font-size:17px;line-height:1.55}.trl-hf-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;margin-top:30px}.trl-hf-card{padding:28px;border:1px solid rgba(255,255,255,.12);border-radius:24px;background:rgba(255,255,255,.06)}.trl-hf-card span{color:#ff4d52;font-size:9px;font-weight:950;letter-spacing:.16em}.trl-hf-card h3{margin:8px 0 0;color:#fff;font-size:25px;font-weight:950}.trl-hf-card p{margin:10px 0 0;color:rgba(255,255,255,.68);line-height:1.5}.trl-hf-actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:24px}.trl-hf-actions a,.trl-hc-inner a{display:inline-flex;min-height:50px;align-items:center;justify-content:center;padding:0 20px;border-radius:999px;text-decoration:none;font-size:12px;font-weight:950}.trl-hf-primary,.trl-hc-inner a:first-child{background:#c4161c;color:#fff}.trl-hf-secondary,.trl-hc-inner a:last-child{border:1px solid rgba(255,255,255,.2);color:#fff;background:transparent}.trl-hf-inner>small{display:block;margin-top:16px;color:rgba(255,255,255,.5);font-size:11px}.trl-authentic-review{padding:84px 22px;background:#f7f5f2}.trl-ar-inner{max-width:980px;margin:0 auto;text-align:center}.trl-ar-stars{margin-top:14px;color:#c4161c;font-size:18px;letter-spacing:.12em}.trl-ar-inner blockquote{margin:18px auto 0;max-width:900px;color:#111;font-size:clamp(24px,3vw,38px);line-height:1.3;letter-spacing:-.025em;font-weight:750}.trl-ar-inner p{margin:22px 0 0}.trl-ar-inner p strong,.trl-ar-inner p span{display:block}.trl-ar-inner p strong{font-size:14px}.trl-ar-inner p span{margin-top:4px;color:rgba(0,0,0,.55);font-size:12px}.trl-home-final-cta{padding:90px 22px;background:linear-gradient(135deg,#f4f1ef,#fff)}.trl-hc-inner{max-width:980px;margin:0 auto;text-align:center}.trl-home-final-cta h2{max-width:800px}.trl-hc-inner p{max-width:700px;margin:16px auto 0;color:rgba(0,0,0,.62);font-size:17px;line-height:1.55}.trl-hc-inner>div{display:flex;justify-content:center;gap:10px;flex-wrap:wrap;margin-top:26px}.trl-hc-inner a:last-child{border-color:rgba(0,0,0,.16);color:#111}.trl-tech-v10 .trl-v10-review{display:none!important}[id*="highlight-text"],[id*="client_reviews_carousel_JmTNpT"],[id*="reveal-testimonials"]{display:none!important}.trl-power-lab-v6{display:none!important}\
      @media(max-width:700px){.trl-customer-logo-intro{padding:38px 14px 16px}.trl-home-financing-final,.trl-authentic-review,.trl-home-final-cta{padding:62px 14px}.trl-hf-grid{grid-template-columns:1fr}.trl-hf-actions,.trl-hc-inner>div{display:grid;grid-template-columns:1fr}.trl-hf-actions a,.trl-hc-inner a{width:100%}.trl-ar-inner blockquote{font-size:23px}}';
    document.head.appendChild(style);
  }

  function finalize(){
    if(!document.body || !document.body.classList.contains('template-index')) return;
    injectStyles();
    buildTrustBar();
    finalizeLogoProof();
    removeRedundantHighlight();
    finalizeFeatured();
    finalizeWhyTRL();
    remove707Comparison();
    finalizeVideo();
    removeManualReviews();
    finalizeAbout();
    moveSections();
    createFinancing();
    createAuthenticReview();
    createFinalCTA();
    hideCS5(document);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',finalize); else finalize();
  document.addEventListener('shopify:section:load',finalize);
  var observer=new MutationObserver(function(){ hideCS5(document); });
  window.addEventListener('load',function(){ if(document.body) observer.observe(document.body,{childList:true,subtree:true}); });
})();